import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IPortalUserSummary } from 'Modules/Communication/PortalUsers/shared/models/PortalUsers'

const portalSummarySlice = createSlice({
  name: 'portalSummary',
  initialState: {
    data: null as IPortalUserSummary | null,
    error: null,
    loading: false,
  },
  reducers: {
    // Handle payload (_) for redux-saga to pickup
    fetchRequest: (state) => {
      state.loading = true
    },
    fetchSuccess: (state, action: PayloadAction<IPortalUserSummary>) => {
      state.loading = false
      state.error = null
      state.data = action.payload
    },
    fetchError: (state, action) => {
      state.loading = false
      state.error = action.payload
    },
  },
})

export default portalSummarySlice
